module.exports = __webpack_public_path__ + "static/media/tachometer-alt-average.7ecf8563.svg";